import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function SectionFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[800px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-question-answer-line"></i>
            <span>答疑解惑</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            关于樱花漫画网的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <h3 className="font-heading text-sm md:text-base text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}